import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { Deal } from '../../modules/deals/types';
import { defaultDealsState } from './state';

export const dealsSlice = createSlice({
  name: 'deals',
  initialState: defaultDealsState,
  reducers: {
    fetchDeals: (state, _: PayloadAction<string>) => ({
      ...state,
      loading: true,
      error: null
    }),
    fetchDealsSuccess: (state, { payload }: PayloadAction<Record<string, Deal>>) => ({
      deals: payload,
      loading: false,
      error: null
    }),
    fetchDealsFailure: (state, { payload }: PayloadAction<string>) => ({
      ...state,
      loading: false,
      error: `Error fetching deals: ${payload}`
    })
  }
});

export const { fetchDeals, fetchDealsSuccess, fetchDealsFailure } = dealsSlice.actions;

export const reducer = dealsSlice.reducer;
